<template>
    <div>
        <CRow>
            <CCol>
                <ejs-grid ref='grid'
                          :dataSource='referencePriceData'
                          :allowFiltering='true'
                          :allowPaging='true'
                          :allowResizing='true'
                          :allowReordering='true'
                          :allowSorting='true'
                          :toolbar='toolbar'
                          :editSettings='editSettings'
                          :pageSettings='pageSettings'
                          :filterSettings='filterOptions'
                          :toolbarClick='toolbarClick'
                          :allowExcelExport='true'
                          :excelExportComplete='excelExportComplete'
                          :query='gridQuery'
                          :actionComplete="actionComplete"
                          :queryCellInfo='customiseCell'>
                    <e-columns>
                        <e-column field='id' headerText='Id' :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='tradablePeriod' headerText='Tradeable Period' width=120 :allowEditing="false"></e-column>
                        <e-column field='price' headerText='Price' editType="numericEdit" format="n3" :edit="numericParams" width=120></e-column>
                        <e-column field='referenceTypeId' headerText='Reference Type' editType='dropdownedit' :edit='refPriceParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='referenceTypes'></e-column>
                    </e-columns>
                </ejs-grid>
                <div id="modalTarget" class="control-section; position:relative" style="height:350px;">
                    <ejs-uploader ref="uploadObj" id='defaultfileupload' name="uploadFile" :allowedExtensions="extensions" :uploading="addHeaders" :asyncSettings="path" :success="onUploadSuccess" :failure="onUploadFailed" :multiple='multiple'></ejs-uploader>
                </div>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import { DropDownList } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from "@syncfusion/ej2-vue-inputs";
    import SyncHelper from '../../common/syncfusion'
    import gridOptions from '../../common/gridOptions'
    import store from '../../store';
    import { Query } from '@syncfusion/ej2-data'
    import urls from '../../common/urls'
    import authToken from '../../common/authToken';


    Vue.use(GridPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DatePickerPlugin);

    let referenceTypes = SyncHelper.getDataManager('utils/referenceTypes');
    let refTypeObj, refTypeElem;
    export default {
        name: 'ReferencePriceForm',
        created() {
        },
        data() {
            return {
                referenceTypes: referenceTypes,
                referencePriceData: SyncHelper.getDataManager("referenceprice"),
                pageSettings: gridOptions.pageSettings,
                gridQuery: new Query().addParams("contractId", store.state.selectedContractId),
                editSettings: {
                    showConfirmDialog: false,
                    allowEditing: store.state.permissions["Permissions.ReferencePrice.Update"],
                    mode: 'Normal'
                },
                toolbar: ['Edit', 'ExcelExport'],
                filterOptions: gridOptions.filterSettings,
                path: {
                    saveUrl: `${urls.apiBaseUrl}referenceprice/import?contractId=${store.state.selectedContractId}`
                },
                numericParams: {
                    params: {
                        decimals: 4,
                        format: "n4",
                        min: 0
                    }
                },
                marketPriceUnit: store.state.contractMarketUnit,
                extensions: ' .xls, .xlsx',
                multiple: false,
                addHeaders: function (args) {
                    args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
                },
                refPriceParams: {
                    create: () => {
                        refTypeElem = document.createElement('input');
                        return refTypeElem;
                    },
                    read: () => {
                        return refTypeObj.value;
                    },
                    destroy: () => {
                        refTypeObj.destroy();
                    },
                    write: (args) => {
                        refTypeObj = new DropDownList({
                            dataSource: referenceTypes,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Reference Type',
                            floatLabelType: 'Always'
                        });
                        refTypeObj.appendTo(refTypeElem);
                    }
                },
            }
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    this.$refs.grid.getColumns()[0].visible = true;
                }
                gridOptions.excelExport(args, "ReferencePrice.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.getColumns()[0].visible = false;
                this.$refs.grid.hideSpinner();
            },
            //actionBegin(args) {
            //    if (args.requestType === 'beginEdit') {
            //        apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/PeriodDeadline/${args.rowData.contractTradeablePeriodId}`).then(it => {
            //            datePickerObj.max = it.data.lastDay;
            //        }).catch(
            //            response => {
            //                var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
            //                gridOptions.errorAlert("Error: " + message);
            //            }
            //        );
            //    }
            //},
            actionComplete(args) {
                if (args.requestType === 'save') {
                    this.$refs.grid.refresh();
                }
            },
            customiseCell: function (args) {
                if (args.column.field === 'price') {
                    args.cell.textContent = args.cell.textContent + " " + "[" + this.marketPriceUnit + "]";
                }
            },
            onUploadFailed: function (args) {
                this.$refs.grid.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            },
            onUploadSuccess: function (args) {
                if (JSON.parse(args.e.currentTarget.response).status === "OK with Errors") {
                    let fileName = JSON.parse(args.e.currentTarget.response).file.fileDownloadName;
                    let base64String = JSON.parse(args.e.currentTarget.response).file.fileContents;
                    const byteCharacters = atob(base64String);
                    const byteNumbers = new Uint8Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const blob = new Blob([byteNumbers], { type: 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    const element = document.createElement('a');
                    element.href = url;
                    element.download = fileName;
                    document.body.appendChild(element);
                    element.click();
                    element.remove();
                    window.URL.revokeObjectURL(url);
                    var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                    args.statusText = statusMessage.trim();
                }
                this.$refs.grid.refresh();
            },
        },
        computed: {
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style scoped>
</style>